module.exports = __webpack_public_path__ + "img/FamilyForumToolkit.79b27caa.svg";